import React from 'react';
import { PauseCircleOutlined } from '@ant-design/icons';
import { getTranslatedLabel } from './FooterVoice.constants';
import VoiceIconButton from './VoiceIconButton';

const RecordingVoicePreview = ({
    recordSeconds,
    waveRef,
    wavePathRef,
    pauseRecording,
    formatTime,
    t,
    isDarkMode,
    iconSize,
    disableTooltip,
}) => {
    const tt = (key, fallback) => getTranslatedLabel(t, key, fallback);

    return (
        <div
            data-testid="voice-recording"
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                width: '100%',
                minWidth: 0,
                padding: '6px 8px',
                border: `1px solid ${isDarkMode ? '#434343' : '#e6edf3'}`,
                borderRadius: 999,
                background: isDarkMode ? '#262626' : '#f8fafc'
            }}
        >
            <VoiceIconButton
                label={tt('stop', 'Stop')}
                danger
                isDarkMode={isDarkMode}
                disableTooltip={disableTooltip}
                icon={<PauseCircleOutlined style={{ fontSize: iconSize }} />}
                onClick={pauseRecording}
            />

            <span
                style={{
                    fontSize: 12,
                    fontWeight: 600,
                    color: isDarkMode ? '#fff' : '#334155',
                    whiteSpace: 'nowrap'
                }}
            >
                {formatTime(recordSeconds)}
            </span>

            <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
                <div ref={waveRef} style={{ width: '100%', height: 28, overflow: 'hidden' }}>
                    <svg viewBox="0 0 600 24" preserveAspectRatio="none" style={{ width: '100%', height: '100%', display: 'block' }}>
                        <path ref={wavePathRef} d="M0 12 L600 12" fill="none" stroke="#1DA1F2" strokeWidth="2" />
                    </svg>
                </div>
            </div>
        </div>
    );
};

export default RecordingVoicePreview;
